import {NestedModel} from "../nestedmodel";
import { DeviceFeatureSets } from "./deviceFeatureSets";
import { Tasks } from "./tasks";

export class CpeId extends NestedModel {
    constructor(props, attributes) {
        super(props, Object.assign({}, attributes));
        this.ipHistory = new NestedModel({value: 'ipHistory', parent: this});
        this.cachedParams = new NestedModel({value: 'cachedParams', parent: this});
        this.variables = new NestedModel({value: 'variables', parent: this});
        this.alarms = new NestedModel({value: 'alarms', parent: this});
        this.alarmHistory = new NestedModel({value: 'alarmHistory', parent: this});
        this.diagResults = new NestedModel({value: 'diagResults', parent: this});
        this.connectedDevices = new NestedModel({value: 'connectedDevices', parent: this});
        this.configFiles = new NestedModel({value: 'configFiles', parent: this});
        this.cancelAllTasks = new NestedModel({value: 'cancelAllTasks', parent: this});
        this.deviceFeatureSets = new DeviceFeatureSets({value: 'deviceFeatureSets', parent: this});
        this.diagResultHistory = new NestedModel({value: 'diagResultHistory', parent: this});
        this.diagResultDailyHistory = new NestedModel({value: 'diagResultDailyHistory', parent: this});
        this.deviceFeatureSetHistory = new NestedModel({value: 'deviceFeatureSetHistory', parent: this});
        this.deviceFeatureSetDailyHistory = new NestedModel({value: 'deviceFeatureSetDailyHistory', parent: this});
        this.tasks = new Tasks({value: 'tasks', parent: this});
    }
}
